<template>
    <div class="box-body">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="box-body"></div>
            </div>
        </div>

        <div class="">
            <div style="margin-bottom: 10px">

                <el-row type="flex" class="filters-container">
                    <div style="margin-right:1%">
                    <countries-group :filter="filters[1]" :show-all-button="true" v-on:update-filter="updateFilter"></countries-group>
                    </div>
                    <el-col :span="8">
                        <el-input v-model="filters[0].value" @input="filtrando" placeholder="Buscar"></el-input>
                    </el-col>
                    <el-col :span="8" style="margin-left:1%">
                        <el-button v-if="download_report_visible" type="primary" @click="downloadProvidersData" data-cy="generarReporte" >Generar Reporte</el-button>
                    </el-col>
                </el-row>
            </div>
        </div>


        <data-tables v-loading="loading" id="tablaReporteProveedores" :data="providersData" :pagination-props="{ pageSizes: [10, 20, 30] }"  :filters="filters">
          <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" width="200" :align="title.align"></el-table-column>
        </data-tables>
    </div>
</template>

<script>
  require('moment')
  import Vue from 'vue'
  import api from '../../api'
  import ElementUI from 'element-ui'
  import DataTables from 'vue-data-tables'
  import 'element-ui/lib/theme-chalk/index.css'
  import lang from 'element-ui/lib/locale/lang/es'
  import locale from 'element-ui/lib/locale'

  Vue.use(ElementUI)
  locale.use(lang)
  Vue.use(DataTables)

  import ButtonGroup from './ButtonGroup.vue'

  export default {
    components: {
      'countries-group': ButtonGroup
    },
    data () {
      return {
        country: '',
        providersData: [],
        loading: false,
        download_report_visible: true,
        titles: [{ // Columnas que se van a mostrar
          prop: 'Compania',
          label: 'Compañía',
          align: 'left'
        },
        {
          prop: 'idFiscal',
          label: 'Identificación Fiscal',
          align: 'center'
        },
        {
          prop: 'idType',
          label: 'Tipo de Identificación',
          align: 'center'
        },
        {
          prop: 'Proovedor_fecha_creacion',
          label: 'Fecha de creación',
          align: 'center'
        },
        {
          prop: 'Acepto_Codigo_etica',
          label: 'Cod.Ética',
          align: 'center'
        },
        {
          prop: 'Acepto_Codigo_compliance',
          label: 'Cod.Compliance',
          align: 'center'
        },
        {
          prop: 'Importacion_SAP',
          label: 'Importación SAP',
          align: 'center'
        },
        {
          prop: 'Etapa',
          label: 'Etapa',
          align: 'center'
        },
        {
          prop: 'Aprobar_DG',
          label: 'Aprobación D.Generales',
          align: 'center'
        },
        {
          prop: 'DG_Aprobado_por',
          label: 'Aprobado por',
          align: 'center'
        },
        {
          prop: 'Aprobar_DI',
          label: 'Aprobación D.Impositivos',
          align: 'center'
        },
        {
          prop: 'DI_Aprobado_por',
          label: 'Aprobado por',
          align: 'center'
        },
        {
          prop: 'Aprobar_DB',
          label: 'Aprobación D.Bancarios',
          align: 'center'
        },
        {
          prop: 'DB_Aprobado_por',
          label: 'Aprobado por',
          align: 'center'
        },
        {
          prop: 'Rechazar_DG',
          label: 'Rechazo D.Generales',
          align: 'center'
        },
        {
          prop: 'DG_Rechazado_por',
          label: 'Rechazado por',
          align: 'center'
        },
        {
          prop: 'Rechazar_DI',
          label: 'Rechazo D.Impositivos',
          align: 'center'
        },
        {
          prop: 'DI_Rechazado_por',
          label: 'Rechazado por',
          align: 'center'
        },
        {
          prop: 'Rechazar_DB',
          label: 'Rechazo D.Bancarios',
          align: 'center'
        },
        {
          prop: 'DB_Rechazado_por',
          label: 'Rechazado por',
          align: 'center'
        }],
        filters: [
          {
            prop: ['Compania', 'idFiscal', 'Etapa'],
            value: ''
          },
          {
            prop: 'codCountry',
            value: ''
          }
        ]
      }
    },
    watch: {
      loading: {
        handler: 'performFiltering',
        immediate: true
      }
    },
    methods: {
      performFiltering () {
        if (!this.loading) {
          this.download_report_visible = true
        }
      },
      filtrando () {
        const d = this.filterLogs(this.providersData)
        this.download_report_visible = (d.length > 0)
        // console.log(this.filters[0].value.toLowerCase() + ' ' + d.length + ' ' + this.download_report_visible + ' ' + JSON.stringify(d))
      },
      getProvidersData () {
        this.loading = true
        let that = this
        api.request('GET', 'api/getProvidersLog')
          .then(response => {
            that.loading = false
            var data = response.data
            if (data.error) {
              return
            }
            if (data) {
              this.renameOldData(data)
              this.filtrando()
              return data.data
            }
          })
          .catch(error => {
            that.loading = false
            this.$store.commit('TOGGLE_LOADING')
            console.log(error)
          })
      },
      renameOldData (data) {
        this.providersData = data.data.map((obj) => {
          for (const key in obj) {
            if (obj.hasOwnProperty(key) && typeof obj[key] === 'string') {
              if (obj[key] === '1999-12-12 00:00:00' || obj[key] === null) {
                obj[key] = '✓'
              } else {
                const dateRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/
                if (dateRegex.test(obj[key])) {
                  obj[key] = obj[key].slice(0, 16)
                }
              }
            } else if (obj.hasOwnProperty(key) && obj[key] === null) {
              obj[key] = '✓'
            }
          }
          return obj
        })
      },
      downloadProvidersData () {
        const data = this.providersData
        const filteredData = this.filterLogs(data)
        console.log(filteredData)
        if (filteredData.length === 0) {
          alert('No puedes generar un reporte con la tabla vacia')
          return
        }
        const csvData = this.makeCsvLogs(filteredData)
        this.downloadCsv(csvData)
      },
      filterLogs (data) {
        const search = this.filters[0].value.toLowerCase()
        const country = this.filters[1].value // assuming this is the country filter
        let searchedProviders = []
        let companyName = ''
        let companyFiscalId = ''
        let companyStage = ''

        data.map(function (data) {
          companyName = data.Compania.toLowerCase()
          companyFiscalId = data.idFiscal
          companyStage = data.Etapa.toLowerCase()

          if ((search === '' || companyName.includes(search) || companyFiscalId.includes(search) || companyStage.includes(search)) && (country === '' || data.codCountry === country)) {
            searchedProviders.push(data)
          }
        })

        return searchedProviders
      },
      makeCsvLogs (data) {
        let csvRows = []
        this.headers = Object.keys(data[0])
        csvRows.push(this.headers.join(','))
        data.map(function (data) {
          const values = Object.values(data).join(',')
          csvRows.push(values)
        })
        return csvRows.join('\n')
      },
      downloadCsv (data) {
        const blob = new Blob([data], {type: 'text/csv'})
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.setAttribute('href', url)
        link.setAttribute('download', 'logs.csv')
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },
      updateFilter (updatedFilter) {
        const index = this.filters.findIndex(f => f.prop === updatedFilter.prop)
        this.filters[index].value = updatedFilter.value
        this.filtrando()
      }
    },
    beforeMount () {
      this.getProvidersData()
    }
}
</script>

<style>
  .datetime-picker input {
    height: 4em !important;
  }

  .calification-reason {
    margin-top: 20px;
    border-radius: 5px;
    background-color: #EEE;
  }

  .height-enter-active {
    transition: all 0.4s ease-in-out;
  }

  .height-enter,
  .height-leave-to {
    transform: scaleY(0);
  }

  .el-dialog_wrapper,
  .el-dialog {
    overflow: hidden !important;
  }

  .el-dialog .el-table {
    height: calc(100vh - 278.87px);
    overflow: auto !important;
  }

.input-label {
    display: inline-block;
    padding: 2px 10px;
  }

  .filters-container_button {
      display:flex;
      justify-content:flex-end;
  }

@media only screen and (max-width: 1000px) {
    .filters-container{

    }
    .filters-container_button {
      width: 100%;
      margin-top: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// ReportTable.vue?f822eb30